import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { Result } from '@digibricks/domains';
import { LlmModel, LlmProvider } from '../../../../core';
export var LlmProviderApiMapper = /*#__PURE__*/function () {
  function LlmProviderApiMapper() {
    _classCallCheck(this, LlmProviderApiMapper);
  }

  _createClass(LlmProviderApiMapper, [{
    key: "toDomain",
    value: function toDomain(dto) {
      var _dto$models;

      var models = [];

      var _iterator = _createForOfIteratorHelper((_dto$models = dto.models) !== null && _dto$models !== void 0 ? _dto$models : []),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var modelDto = _step.value;
          var modelResult = this.toModel(modelDto);

          if (modelResult.isFailure) {
            return Result.fail(modelResult.error);
          }

          models.push(modelResult.getValue());
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return LlmProvider.create({
        id: dto.id,
        name: dto.name,
        baseUrl: dto.baseUrl,
        status: dto.status,
        models: models
      });
    }
  }, {
    key: "toModel",
    value: function toModel(dto) {
      return LlmModel.create({
        name: dto.name,
        displayName: dto.displayName,
        description: dto.description,
        isDefault: dto.isDefault,
        type: dto.type,
        isSummaryModel: dto.isSummaryModel,
        creditInputPer1kTokens: dto.creditInputPer1kTokens,
        creditOutputPer1kTokens: dto.creditOutputPer1kTokens,
        creditCacheWritePer1kTokens: dto.creditCacheWritePer1kTokens,
        creditCacheReadPer1kTokens: dto.creditCacheReadPer1kTokens,
        creditCacheStoragePer1kTokensHour: dto.creditCacheStoragePer1kTokensHour,
        providerId: dto.providerId
      });
    }
  }]);

  return LlmProviderApiMapper;
}();